var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container",style:(_vm.bkg_style)},[(_vm.event)?_c('RaisedCountUp'):_vm._e(),_c('TimeCountDown'),_c('Message'),_c('QRCode')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }